// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssVersionSettingSchema = z.enum(['V3_1','V4_0'] as const);

export type CvssVersionSettingType = `${z.infer<typeof CvssVersionSettingSchema>}`

export default CvssVersionSettingSchema;
